import Hero from "./components/Hero";
import CarSpecs from "./components/CarSpecs";
import AsSeenOnLogos from "./components/AsSeenOnLogos";
import Gallery from "./components/Gallery";
import React, { useEffect, useRef } from "react";

const CarCompetitionForDesktop = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (containerRef.current === null) {
      return;
    }
    const onObserving: IntersectionObserverCallback = entries => {
      const moveButtonUp = new CustomEvent("moveButtonUp", { detail: entries[0].isIntersecting });
      window.dispatchEvent(moveButtonUp);
    };
    const observer = new IntersectionObserver(onObserving);
    observer.observe(containerRef.current!);
    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <>
      <div className="relative flex flex-col size-full lg:min-h-[calc(100vh-60px)]" ref={containerRef}>
        <Hero />
      </div>
      <div className="px-8 py-16">
        <div className="relative flex flex-col gap-16 w-full max-w-[1360px] mx-auto">
          <CarSpecs />
          <AsSeenOnLogos />
          <Gallery />
        </div>
      </div>
    </>
  );
};

export default CarCompetitionForDesktop;
